var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasActiveAssi)?_c('ion-buttons',{attrs:{"slot":"end"},slot:"end"},[_c('ion-button',{staticClass:"bigger",on:{"click":_vm.handleClick}},[_c('ion-icon',{attrs:{"name":"alarm","icon-only":""}}),_c('ion-icon',{attrs:{"name":"arrow-forward","icon-only":""}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }